export default "__VITE_ASSET__696e3a53__"